import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ManageCustomerUsageModalPage } from './manage-customer-usage-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ManageCustomerUsageModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ManageCustomerUsageModalPage]
})
export class ManageCustomerUsageModalPageModule {}
